"use strict";

var processInclude = require("./util");

$(document).ready(function () {
    processInclude(require("./product/detail"));
    processInclude(require("./product/stringing"));
    processInclude(require("./product/videoFrame"));
    processInclude(require("./product/swatch"));
    processInclude(require("./product/zoomPopin"));
    processInclude(require("./product/carouselAccessibility"));

    if ($(".js-zendesk-widget").length) {
        setTimeout(() => {
            processInclude(require("./components/zendeskClone"));
        }, 500);
    }

    if ($(".m-set-details").length) {
        processInclude(require("./product/setDetails"));
    }
});

$(window).on("load", function () {
    if (window.location.hash === "#description") {
        setTimeout(() => {
            $("html").animate({
                scrollTop: $(".js-pdp-description").offset().top - $(".l-header").height()
            }, 500);
        }, 2000);
    }

    processInclude(require("./product/almaWidget"));
});

require("jquery-zoom/jquery.zoom.min.js");
